import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * CollapsibleToggle — the shared header row for every collapsible block in the
 * Command Center. Reads as a real button: bordered row, hover state and a
 * visible chevron affordance, so it is obvious it expands and collapses.
 * Used by CollapsibleList and by panels that own their own open state.
 */
export const CollapsibleToggle = ({ open, onToggle, title, testid, icon = null, size = 'base' }) => (
    <button
        type="button"
        onClick={onToggle}
        data-testid={testid}
        aria-expanded={open}
        className="w-full min-h-[44px] flex items-center gap-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/60 px-3 py-2.5 text-left font-semibold text-slate-800 dark:text-slate-100 hover:bg-slate-100 hover:border-slate-300 dark:hover:bg-slate-800 dark:hover:border-slate-500 active:scale-[0.995] transition-colors"
    >
        {icon}
        <span className={size === 'lg' ? 'text-lg' : 'text-base'}>{title}</span>
        <span className="ml-auto inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-slate-300 dark:border-slate-600 text-slate-600 dark:text-slate-300">
            <ChevronDown className={`w-4 h-4 transition-transform ${open ? '' : '-rotate-90'}`} />
        </span>
    </button>
);

/**
 * CollapsibleList — a list wrapper that starts COLLAPSED by default so the
 * manager Command Center stays calm as activity accumulates live. Mirrors the
 * Vehicles inventory collapse pattern (AutomotiveInventoryPanel).
 */
export const CollapsibleList = ({ title, count = null, testid, icon = null, defaultOpen = false, children }) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <section className="space-y-3" data-testid={testid}>
            <CollapsibleToggle
                open={open}
                onToggle={() => setOpen((o) => !o)}
                testid={`${testid}-toggle`}
                icon={icon}
                title={`${title}${count != null ? ` (${count})` : ''}`}
            />
            {open && <div data-testid={`${testid}-body`}>{children}</div>}
        </section>
    );
};

export default CollapsibleList;
